// This class matches the backend UpsertUserLinkedServiceRequest record.
import type { Credential, ApiKeyCredential, BasicCredential, OAuth2Credential, BasicTimeBasedCredential } from '@/models/responses/IUserLinkedService';

export class UpsertUserLinkedServiceRequest {
  constructor(
    public tenantId: number,
    public linkedServiceId: string,
    public endpointUrl: string,
    public credentials: Credential
  ) {}
}

export class AxenitaUpsertUserLinkedServiceRequest extends UpsertUserLinkedServiceRequest {
  constructor(
    public tenantId: number,
    public linkedServiceId: string,
    public endpointUrl: string,
    public credentials: BasicCredential | ApiKeyCredential | OAuth2Credential | BasicTimeBasedCredential
  ) {
    super(tenantId, linkedServiceId, endpointUrl, credentials);
  }
}
